import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { getApiBaseUrl } from '@/utils/runtimeApi';
import { formatApiErrorDetail } from '@/utils/authErrors';
import { toast } from 'sonner';

const API = getApiBaseUrl();

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email }, { withCredentials: true });
      setSubmitted(true);
      toast.success('Şifre sıfırlama isteği alındı');
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Şifremi Unuttum"
      subtitle="Email adresini gir. Hesap kayıtlıysa güvenli şifre sıfırlama bağlantısı oluşturulur."
      footer={<span><Link to="/login" className="font-medium text-sky-700 underline" data-testid="forgot-password-login-link">Giriş ekranına dön</Link></span>}
    >
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
        <div className="space-y-2">
          <Label htmlFor="forgot-password-email">Email</Label>
          <Input id="forgot-password-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-password-email-input" />
        </div>
        <Button type="submit" className="h-11 w-full" disabled={loading} data-testid="forgot-password-submit-button">
          {loading ? 'Bağlantı hazırlanıyor...' : 'Şifre Sıfırlama Bağlantısı Oluştur'}
        </Button>
        {submitted ? <p className="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800" data-testid="forgot-password-success-message">İstek alındı. Hesap kayıtlıysa sıfırlama bağlantısı oluşturuldu.</p> : null}
      </form>
    </AuthLayout>
  );
}